import AOS from './configs/AOS.json'
import IOS from './configs/IOS.json'

export const MoveType = Object.freeze({
  REPLACE: 'replace',
  PUSH: 'push'
})

export const Location = Object.freeze({
  HOME: 0,
  SHOP: 1,
  ORDER_SHEET: 2,
  DELIVERY_TRACKING: 3,
  ORDER_FAIL: 4,
  ORDER_HISTORY_DETAIL: 5,
  ORDER_HISTORY_DELIVERY_TRACKING_URL: 6,
  LOGIN: 7,
  PRODUCT: 8,
  RETURN_EXCHANGE: 9,
  ORDER_HISTORY: 10,
  HISTORY_TO_SHOP: 11,
  HISTORY_DETAIL_TO_SHOP: 12
})

export const Action = Object.freeze({
  CLOSE: 'closeWebview',
  ORDER_BADGE: 'showOrderBadge',
  REFRESH_TOKEN: 'refreshToken',
  REFRESH_WEBVIEW: 'refreshWebview',
  REFRESH_ORDER_HISTORY: 'refreshOrderHistory'
})

// TODO PGCARD 통합 필요. url 동적으로 변경됨. src/presentationals/v2/components/containers/PreOrderPaymentButtonContainer/index.vue:87
export const Smartbaedal = Object.freeze({
  LOGIN: 'smartbaedal://api?json={"func": "goPage", "arg": {"page": "login"}}'
  // PGCARD: 'smartbaedal://api?json={"func": "goPage", "arg": {"page": "pgcard", "url": ""}}'
})

const toQueryString = (params = {}, encoding = false) => {
  let url = ''

  const paramsKeys = Object.keys(params)
  const paramsValues = Object.values(params)

  if (paramsKeys.length > 0) {
    url += '?'

    paramsKeys.forEach((param, idx) => {
      url += `${param}=${encoding ? encodeURIComponent(paramsValues[idx]) : paramsValues[idx]}`

      if (idx < paramsKeys.length - 1) url += '&'
    })
  }

  return url
}

class AppManager {
  constructor() {
    // Beta, Live에 따라 상태 바뀜
    this.entry = process.env.VUE_APP_DEEP_LINK_PROTOCOL
    this.actionEntry = process.env.VUE_APP_BAEMIN_ACTION_DEEP_LINK_PROTOCOL
  }

  /*
    Move Function
    no write history move
    params:
    - location: Location
    - isAndroid: Boolean
    - MoveType: MoveType
    - params: parameters
  */
  move(location, isAndroid, moveType = MoveType.REPLACE, params = {}) {
    const locations = isAndroid ? AOS : IOS
    let url = `${this.entry}${Object.values(locations)[location]}`

    url += toQueryString(params, true)

    if (moveType === MoveType.PUSH) window.location.href = url
    else window.location.replace(url)
  }

  // FIXME 동적인 URL 에 대한 화면 전환 API 를 우선 사용
  moveSimple(url, moveType = MoveType.REPLACE) {
    if (moveType === MoveType.PUSH) window.location.href = url
    else window.location.replace(url)
  }

  /*
    Action Function
    Native Action Function
    params:
    - action: Action
    - MoveType: MoveType
    - params: parameters
  */
  action(action, moveType = MoveType.REPLACE, params = {}) {
    let url = `${this.actionEntry}${action}`

    url += toQueryString(params)

    if (moveType === MoveType.PUSH) window.location.href = url
    else window.location.replace(url)
  }
}

export default AppManager
